var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"pt-3"},[_c('footer-top'),_c('footer-back-to-top'),_c('footer-bottom-vue')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }